<template>
    <div class="box">
        <div class="content">
            <div class="img">
                <img :src="player.image" :alt="player.name"/>
            </div>
            <div class="text">
                <h1>{{ player.name }}</h1>
                <p>{{ player.desc }}</p>
                <p>Statut : <b v-if="!player.status">Non </b><b>Disponible</b></p>
                <p>Prix : <b v-text=player.price></b>M€ </p>
            </div>
        </div>
        <input v-if="player.status" type="button" v-on:click="ClicPlayer" value="Ajouter au panier"/>
    </div>
</template>

<script>
    export default {
        name: "Player",
        props: {
            player: Object
        },
        methods: {
            ClicPlayer: function () {
                this.$emit('cart-add-player', this.player)
            }
        }
    }
</script>

<style scoped>
    .box {
        display: flex;
        flex-direction: column;
        border: 2px solid chartreuse;
        border-radius: 20px;
        padding: 6px;
        margin: 2px;
    }

    .content {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        width: 100%;
        /*background: #ccc;*/

    }

    .img {
        /*background-color: red;*/
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
    }

    .text {
        flex: 3;
        /*background-color: aquamarine;*/
    }

    img {
        max-width: 100%;
        max-height: 200px;
    }
</style>